var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobExpiredTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.499999C3.86 0.499999 0.500001 3.86 0.500001 8C0.5 12.14 3.86 15.5 8 15.5ZM8.75 4.25L8.75 5.75L7.25 5.75L7.25 4.25L8.75 4.25ZM8.75 11.75L8.75 7.25L7.25 7.25L7.25 11.75L8.75 11.75Z",
    fill: "#00B1E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobExpiredTip);
export default __webpack_public_path__ + "static/media/job-expired-tip.1f82eeb4348582a4f82478472ca232c6.svg";
export { ForwardRef as ReactComponent };